import React, { useCallback, useMemo } from "react";
import { Button, Box, Typography } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState, useAppDispatch } from "../../store";
import { sendMessageToAgent } from "../../store/userSlice";
import { v4 as uuid } from "uuid";
import styles from "./chatwindow.module.css";

export default function ManpowerCostButton(): JSX.Element {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();

  // Memoized selectors
  const currentAgent = useSelector(
    (state: RootState) => state.agents?.currentAgent,
  );
  const agentLoading = useSelector((state: RootState) => state.user.loading);

  // Memoize session ID
  const sessionId = useMemo(
    () => searchParams.get("sessionId"),
    [searchParams],
  );

  const handleStartCalculator = useCallback(() => {
    if (!currentAgent) return;

    const questionId = uuid();
    const timestamp = new Date().toISOString();

    const payload = {
      agentId: currentAgent.id,
      message: "Start calculator",
      questionId,
      timestamp,
      agentEndpoint: currentAgent.endpoint,
      sessionId,
    };

    dispatch(sendMessageToAgent(payload));
  }, [currentAgent, sessionId, dispatch]);

  return (
    <Box className={styles.manpowerStartContainer}>
      {/* Header */}
      <Box className={styles.manpowerStartHeader}>
        <Box className={styles.manpowerStartHeaderIcon}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="#00A3A3">
            <circle cx="12" cy="12" r="3" />
          </svg>
        </Box>
        <Typography variant="subtitle2" className={styles.manpowerStartHeaderText}>
          MANPOWER COST CALCULATOR
        </Typography>
      </Box>

      {/* Description */}
      <Typography variant="body2" className={styles.manpowerStartDescription}>
        Let's put together a manpower cost estimate. Click below to begin.
      </Typography>

      {/* Button */}
      <Box className={styles.manpowerStartButtonWrapper}>
        <Button
          variant="contained"
          onClick={handleStartCalculator}
          disabled={agentLoading}
          className={styles.manpowerStartButton}
        >
          Start Calculator →
        </Button>
      </Box>
    </Box>
  );
}
